import { CenterContent } from "../../CenterContent";

export function FrontKdistGuest() {
    return <CenterContent >
        <h1 className="Jumbo">FrontKdistGuest</h1>
    </CenterContent >
}
